import React from 'react';
import Typed from 'react-typed';

const Footer = () => {
    return (
        <footer className='container mt-5 p-3'>
            <p className="text-secondary text-center"><Typed strings={['&copy; BIOTECH PHARMACEUTICALS (AY) | ALL RIGHTS RESERVED']} startDelay={1000} typeSpeed={70} onComplete={(self) => self.cursor.remove()} /></p>
        </footer>
    );
};

export default Footer;